import { aruba } from 'grommet-theme-aruba'

let pony = { ...aruba }

pony.global.colors.brand = '#008752'
pony.global.colors.focus = 'accent-3'

pony.global.colors.control.dark = '#004631'
pony.global.colors.control.light = '#c9dd0a'

pony.global.colors.statusCritical = '#dd3000'
pony.global.colors.statusOk = '#168346'
pony.global.colors.statusWarning = '#fda502'

export default pony